import { useState } from 'react'
import { ConcreteMaterialFormItemProps, ConcreteMaterialItem } from './types'
import { useConcreteNotificationsContext } from '../../../../../../ConcreteNotificationsContext'
import { LabeledValueType } from 'components/CIMSSelect/types'
import CIMSCollapse from 'components/CIMSCollapse'
import GroupFallback from '../../../../../../components/GroupFallback'
import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { alphabeticalSort } from '@cims-online/shared'

const ConcreteMaterialFormItem: React.FC<ConcreteMaterialFormItemProps> = ({
  onChange,
  value,
}) => {
  const { data } = useConcreteNotificationsContext()
  const [values, setValues] = useState<Map<string, ConcreteMaterialItem>>(
    (value ?? []).reduce(
      (map, v) => map.set(v.concreteMaterialId, v),
      new Map<string, ConcreteMaterialItem>()
    )
  )
  const change = (id: string, recipients: LabeledValueType[]) =>
    setValues((prev) => {
      const map = new Map(prev)
      map.set(id, { concreteMaterialId: id, recipients })
      onChange?.([...map.values()])
      return map
    })

  return (
    <CIMSCollapse
      noPanelsContent={<GroupFallback group="Concrete Materials" />}
      panels={data.concreteMaterials
        .sort(alphabeticalSort('placementType'))
        .map(({ globalId, placementType }) => {
          return {
            key: globalId,
            header: placementType ?? '',
            children: (
              <CIMSFormItem label="Recipients">
                <RecipientsSelect
                  value={values.get(globalId)?.recipients ?? []}
                  onChange={(recipients) =>
                    change(globalId, recipients as LabeledValueType[])
                  }
                />
              </CIMSFormItem>
            ),
          }
        })}
    />
  )
}

export default ConcreteMaterialFormItem
